import React from "react";
import { Row, Col } from "react-bootstrap";
import { RiLoginBoxLine, RiLogoutBoxLine, RiTimeLine } from "react-icons/ri";

function EntryStats({analytics}) {
  const stats = [
    { icon: <RiLoginBoxLine />, value: `${analytics?.totalEntry > 0 ? analytics?.totalEntry : 0 }`, label: "Total Entries",  color: "green" },
    { icon: <RiLogoutBoxLine />, value: `${analytics?.totalExit > 0 ? analytics?.totalExit : 0 }`, label: "Total Exits",  color: "red" },
    { icon: <RiTimeLine />, value: `${analytics?.pending > 0 ? analytics?.pending : 0 }`, label: "Pending Inside",   color: "blue" },
    // { icon: <RiTimeLine />, value: `${analytics?.total || 0 }`, label: "Avg. Dwell Time", trend: "+9.3%", color: "purple" },
  ];

  return (
    <Row className="ee-stats">
      {stats.map((s, i) => (
        <Col xl={4} lg={4} md={4} sm={12} key={i}>
          <div className="ee-card">
            <div className={`icon ${s.color}`}>{s.icon}</div>
            <div>
              <h4>{s.value}</h4>
              <p>{s.label}</p>
            </div>
            <span className={`trend ${s.color}`}>{s.trend}</span>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default React.memo(EntryStats);